function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var module;
// LICENSE_CODE ZON
'use strict'; /*jslint react:true, es6:true, node:true*/
var is_node = typeof module == 'object' && module.exports && module.children || typeof global != 'undefined' && global.is_node_webpack;
define(['virt_jquery_all', 'zutil', 'lodash.isequal', 'cookie', 'hola_opt', '/util/url.js', '/util/etask.js', '/util/escape.js', '/util/user_agent.js', '/util/date.js', '/www/hola/pub/util.js', 'pub_config', '/svc/billing/pub/pay_ccardbs.js', '/svc/account/pub/membership.js', '/svc/billing/pub/payutils.js', '/util/storage.js', '/util/array.js', '/util/country.js', '/www/hola/pub/modal.js', '/util/zerr.js', '/util/util.js', '/www/hola/pub/plans_util.js', '/www/hola/pub/experiment_util', '/www/hola/pub/experiment_init'], ($, _, _isEqual, cookie, hopt, zurl, etask, zescape, user_agent, zdate, www_util, config, pay_ccardbs, zmembership, payutils, storage, array, zcountry, modal, zerr, zutil, plans_util, experiment_util, experiment_init) => {
  var E = {};
  var be;
  var url2md5 = config.url2md5;
  var assign = Object.assign;
  E.set_be = _be => {
    be = _be;
  };
  E.sys = user_agent.guess();
  experiment_init = experiment_init.default;
  experiment_util = experiment_util.default;
  E.log = (...args) => console.log(zdate.to_sql_ms(), ...args);
  E.test_log = (...args) => {
    if (E.api.test_env) console.log(zdate.to_sql_ms(), ...args);
  };
  E.test_log_error = (...args) => {
    if (E.api.test_env) console.error(zdate.to_sql_ms(), ...args);
  };
  E.parse_plan_period = str => {
    if (typeof str != 'string' || str.length < 2) return;
    if (hopt.annual_promo_ultra.plan_ids.includes(str)) return '1 Y';
    if (str.startsWith('u')) return str[str.length - 1] + ' ' + str[str.length - 2].toUpperCase();
    return str[0] + ' ' + str[1].toUpperCase();
  };
  E.generic_err = 'There was an error processing the payment';
  var user_membership,
    login_get_user_cache = {};
  var init_from_url = (url_key, def) => {
    var qs = zurl.qs_parse_url(location.href, {
      safe: true
    });
    var v = qs[url_key];
    return v === undefined ? def : +v;
  };
  E.set_ppc_cookie = () => {
    var qs = zurl.qs_parse_url(location.href, {
      safe: true
    });
    var segments = zurl.segments(location.href);
    var utm = {
      m: qs.utm_medium,
      s: qs.utm_source,
      c: qs.utm_campaign
    };
    var ppc_src = qs.gclid || qs.gbraid || qs.wbraid ? 'google' : qs.ad_id ? 'fb' : utm.c && utm.s && utm.m && utm.m.toLowerCase() == 'cpc' ? utm.c : segments[1] == 'join' && (segments[2] || '').toLowerCase() != 'stackcommerce' ? 'ad' : null;
    if (ppc_src) {
      cookie.set('ppc', ppc_src, {
        domain: '.hola.org',
        path: '/',
        expires: zdate.add(zdate(), {
          day: 30
        })
      });
    }
  };
  E.set_payment_cookie = (user, plan, provider) => {
    user = user || {};
    var qs = zurl.qs_parse_url(location.href, {
      safe: true
    });
    var amount = Math.ceil(plan.price);
    var aj_id,
      ref = qs.ref || '';
    if (/trial_ended/.test(ref)) aj_id = `be_aj_trial_time_ended_popup_select_buy_${plan.id}`;else if (/trial_remaining/.test(ref)) aj_id = `be_aj_trial_time_remaining_popup_select_buy_${plan.id}`;
    var data = {
      amount: amount,
      period: plan.period,
      id: plan.id,
      price: plan.price,
      name: plan.name,
      provider,
      user,
      aj_id
    };
    cookie.set('payment', data, {
      domain: '.hola.org',
      path: '/',
      expires: zdate.add(zdate(), {
        hour: 1
      })
    });
    E.perr({
      id: 'www_premium_set_payment_cookie',
      info: {
        data,
        ppc_src: cookie.get('ppc')
      }
    });
    if (!user || !user.emails || user.emails.length == 0) {
      storage.set('update_experiments_after_confirm', JSON.stringify({
        experiment: 'test_email_checkout',
        event: 'www_payment_submit_' + plan.id
      }));
    } else {
      experiment_util.send('test_email_checkout', 'www_payment_submit_' + plan.id, {
        user,
        only_new: true
      });
    }
  };
  E.api = {
    avangate: !!+init_from_url('avangate', false),
    avangate_2pay: !!+init_from_url('avangate_2pay', false),
    use_bluesnap_apm: !!+init_from_url('use_bluesnap_apm', false),
    use_paypal_api: !!+init_from_url('use_paypal_api', true),
    avangate_fallback: +init_from_url('avangate_fallback', !!hopt.www_hola.avangate_fallback),
    test_env: !!+init_from_url('test', false),
    gpay: !!+init_from_url('google_pay', !!_.get(hopt, 'www_hola.google_pay.enabled')),
    // XXX vitaly: disabled apple pay for mobile due to UI bugs
    applepay: !!+init_from_url('apple_pay', !!_.get(hopt, 'www_hola.apple_pay.enabled') && !www_util.sys.mobile),
    avangate_enabled: true
  };
  E.after_payment_page = opt => {
    var qs = zurl.qs_parse_url(location.href, {
      safe: true
    });
    var page = opt.next || qs.next;
    if (page && www_util.is_safe_redirect(page)) return page;
    var email = _.get(opt.user, 'emails[0].value') || opt.email;
    if (opt.bundle == 'toolip') {
      return zescape.uri('https://toolip.io/dashboard/page/plans', {
        thank_you: 1,
        email: email || undefined
      });
    }
    var _opt = {
      utm_nooverride: 1,
      after_payment: 1,
      ref: qs.ref,
      gclid: qs.gclid,
      test: E.api.test_env ? 1 : undefined,
      email: email || undefined,
      coupon: opt.coupon || undefined,
      trans: opt.trans || undefined,
      gateway: opt.gateway || undefined
    };
    zutil.if_set(qs.ext_popup, _opt, 'ext_popup');
    var url = (opt.full_host ? location.host : '') + '/thank_you';
    return zescape.uri(url, _opt);
  };
  E.conf = {};
  var get_test_ref_id = () => _.get(hopt, 'www_hola.test_ref_id');
  E.test = {};
  E.no_test = {};
  E.test_conf = {
    plus_layout2: 1,
    fallback_promo: 1,
    cc_payment: _.get(hopt, 'www_hola.cc_payment'),
    stripe_us_only: _.get(hopt, 'www_hola.payment.stripe.us_only'),
    stripe_usd_only: _.get(hopt, 'www_hola.payment.stripe.usd_only'),
    placebo: _.get(hopt, 'www_hola.test_placebo')
  };
  E.init_plans_ab_test = ref => {
    var qs = zurl.qs_parse_url(location.href, {
      safe: true
    });
    ref = ref || qs.ref || '';
    var cached_test = storage.get_json('plans_ab_test');
    E.test_log('cached plans_ab_test', cached_test);
    var def = _.get(hopt, 'www_hola.plans_ab_tests.default', {});
    var plans_ab_tests = _.get(hopt, 'www_hola.plans_ab_tests', {});
    E.test_log('plans_ab_tests', plans_ab_tests);
    var new_test;
    for (var k in plans_ab_tests) {
      E.test_log('check', k);
      if (k == 'default') continue;
      var test = plans_ab_tests[k];
      if (!test.enabled) continue;
      if (ref.includes(k + '_on')) {
        E.test_log('test is on');
        new_test = {
          name: k,
          value: 'on'
        };
        break;
      }
      if (ref.includes(k + '_off')) {
        E.test_log('test is off', k);
        new_test = {
          name: k,
          value: 'off'
        };
        break;
      }
    }
    var new_test_conf, cached_test_conf;
    if (new_test) new_test_conf = assign({}, def, plans_ab_tests[new_test.name]);
    if (cached_test) {
      var conf = assign({}, def, plans_ab_tests[cached_test.name]);
      if (conf.enabled && conf.ver == cached_test.ver && Date.now() - cached_test.ts < conf.cache_dur * 1000) {
        cached_test_conf = conf;
      }
    }
    E.test_log('cached plans_ab_test conf', cached_test_conf);
    E.test_log('new plans_ab_test conf', new_test_conf);
    if (new_test && (!cached_test_conf || cached_test_conf.override)) {
      new_test.ts = Date.now();
      new_test.ver = new_test_conf.ver;
      E.test_log('cache plans_ab_test');
      storage.set_json('plans_ab_test', new_test);
      if (new_test.value == 'on') new_test.replace = new_test_conf.replace;
      E.plans_ab_test = new_test;
    } else if (cached_test_conf) {
      if (cached_test.value == 'on') cached_test.replace = cached_test_conf.replace;
      E.plans_ab_test = cached_test;
    }
    E.test_log('plans_ab_test', E.plans_ab_test);
  };
  E.init_ab_testing = () => {
    var _location, _location$href;
    if (is_node) return;
    E.init_plans_ab_test();
    var ab_testing = storage.get_json('ab_testing') || {};
    var qs = zurl.qs_parse_url(location.href, {
      safe: true
    });
    function is_testing(id, selector) {
      try {
        var conf = E.test_conf[id];
        if (!conf) return false;
        var conf_res = conf;
        if (conf_res === 1 || conf_res === true) return true;
        if (id in ab_testing && _isEqual(ab_testing[id + '_conf'], conf)) return ab_testing[id];
        var res = experiment_init.rand_select(conf_res, null, selector);
        ab_testing[id + '_conf'] = conf;
        return ab_testing[id] = res;
      } catch (e) {
        E.perr({
          id: 'www_premium_payment_invalid_ab_testing'
        });
      }
    }
    E.test = {
      placebo: is_testing('placebo'),
      plus_layout2: is_testing('plus_layout2'),
      fallback_promo: is_testing('fallback_promo'),
      cc_payment: is_testing('cc_payment', k => hopt.user_country == k),
      stripe_us_only: is_testing('stripe_us_only'),
      stripe_usd_only: is_testing('stripe_usd_only')
    };
    storage.set_json('ab_testing', ab_testing);
    if (+qs.debug_plus_layout2) E.test.plus_layout2 = true;
    if (+qs.debug_fallback_promo) E.test.fallback_promo = true;
    if (qs.debug_cc_payment) E.test.cc_payment = zutil.set({}, qs.debug_cc_payment, true);
    if (qs.with_trial) E.test.cc_payment = zutil.set({}, 'stripe', true);
    if (!((_location = location) !== null && _location !== void 0 && (_location$href = _location.href) !== null && _location$href !== void 0 && _location$href.includes('toolip.io'))) {
      if (zutil.get(E.test, 'cc_payment.avangate') && !(qs['avangate_2pay'] && !+qs['avangate_2pay'])) {
        E.api.avangate = E.api.avangate_2pay = 1;
      }
      if (zutil.get(E.test, 'cc_payment.stripe')) E.api.stripe = 1;
      if (qs.debug_adyen_api || zutil.get(E.test, 'cc_payment.adyen')) E.api.adyen = 1;
      var pconf = _.get(hopt, 'www_hola.payment', {});
      E.api.bs_def = _.get(pconf, 'bluesnap.default');
      if (zutil.get(E.test, 'cc_payment.bluesnap.hpf')) E.api.bluesnap_hpf = 1;else if (zutil.get(E.test, 'cc_payment.bluesnap')) E.api['bluesnap_' + E.api.bs_def] = 1;
      E.api.bluesnap_hpf_enabled = zutil.get(pconf, 'bluesnap.hpf.enabled');
      E.api.stripe_enabled = zutil.get(pconf, 'stripe.enabled');
      E.api.avangate_2pay_enabled = zutil.get(pconf, 'avangate.twopay.enabled');
    }
    if (qs.stripe_us_only !== undefined) E.test.stripe_us_only = +qs.stripe_us_only;
    if (qs.stripe_usd_only !== undefined) E.test.stripe_usd_only = +qs.stripe_usd_only;
    E.api.cc_payment_path = test_collapse(E.test.cc_payment);
    E.test_log('api', E.api);
    E.test_log('test', E.test);
    E.conf.no_stripe = E.test.stripe_us_only && hopt.user_country != 'US';
    E.test_log('ab_testing inited');
  };
  E.set_api = api => {
    E.test_log('set api', api);
    assign(E.api, api);
  };
  var test_collapse = value => {
    var keys = Object.keys(zutil.flatten_obj(value));
    var r = keys[keys.length - 1];
    if (r) return r.replace('_', '.');
  };
  var mk_test_ref = (test_conf, ref) => {
    var res = '';
    for (var id in test_conf) {
      var value = test_conf[id];
      var status = void 0;
      // multi-value option: "test_cc_payment-bluesnap-ext-vat_on__<ref>"
      if (id == 'cc_payment') status = test_collapse(value).split('.').join('_');
      // boolean option: e.g. "test_new_prices_on_<ref>"
      status = status || (value ? 'on' : 'off');
      res += `test_${id}_${status}_`;
    }
    return res + ref;
  };
  var is_test_enabled = (test_id, value) => {
    if (!value) return false;
    if (test_id == 'cc_payment') {
      var participants = Object.values(value).reduce((s, v) => s + !!v, 0);
      return participants > 1;
    }
    return value != 1 && value !== true;
  };
  E.get_ui_test = () => experiment_init.ui_test;
  E.test_ref = (test_id, ref) => {
    test_id = array.copy(Array.isArray(test_id) ? test_id : [test_id]);
    var test_conf = {};
    var _iterator = _createForOfIteratorHelper(test_id),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var tid = _step.value;
        if (is_test_enabled(tid, E.test_conf[tid]) && !E.no_test[tid]) test_conf[tid] = E.test[tid];
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    var experiments = www_util.get_active_tests();
    var filtered_exp = experiments[0] ? experiments.filter(ex => ex && ex.conf && ex.conf.for_vpn_stat) : [];
    for (var i = 0; i < filtered_exp.length; i++) test_conf[filtered_exp[i].id] = filtered_exp[i].value;
    if (Object.keys(test_conf).length) ref = mk_test_ref(test_conf, ref);
    if (E.plans_ab_test && !('' + ref).includes(E.plans_ab_test.name)) {
      ref = E.plans_ab_test.name + '_' + E.plans_ab_test.value + (ref ? '_' + ref : '');
    }
    E.test_log('test_ref', ref);
    return ref;
  };
  E.get_url_ref = () => {
    var _be4;
    var qs = zurl.qs_parse_url(location.href, {
      safe: true
    });
    var ref = qs.ref || '';
    var orig_ref = cookie.get('orig_ref');
    var ppc_src = cookie.get('ppc');
    if (orig_ref && ref != orig_ref && !/^test_(.*)(_off|_on)/.test(orig_ref)) ref = `${ref}_orig_ref_${orig_ref}`;
    if (ppc_src) ref = `ppc_${ppc_src}_${ref}`;
    var test_ref_id = get_test_ref_id();
    if (ref) {
      var app;
      if (cookie.get('is_hola_cr')) {
        var _be2, _be3;
        app = '_app_' + ((_be2 = be) !== null && _be2 !== void 0 && _be2.is_win() ? 'win' : (_be3 = be) !== null && _be3 !== void 0 && _be3.is_mac() ? 'mac' : 'unknown');
      }
      return E.test_ref(test_ref_id, ref + (app || ''));
    }
    var segments = zurl.segments(location.href);
    var s = segments[1];
    if (['unsupported', 'uninstall'].includes(s)) ref = 'holaext-' + ((_be4 = be) !== null && _be4 !== void 0 && _be4.is_firefox() ? 'ff-' : '') + s;else if ((segments[2] || '').toLowerCase() == 'stackcommerce') ref = 'mashable_coupon';
    return E.test_ref(test_ref_id, ref || 'missing');
  };
  E.perr = ({
    id,
    info
  }) => {
    if (E.api.test_env && id.startsWith('www_premium_payment_')) id = id.replace('www_premium_payment_', 'www_premium_payment_test_');
    try {
      var _be5;
      var qs = zurl.qs_parse_url(location.href, {
        safe: true
      });
      info = assign(info || {}, {
        url: location.href,
        ref: E.test_ref(get_test_ref_id(), qs.ref),
        referrer: document.referrer,
        utm_source: qs.utm_source,
        utm_content: qs.utm_content
      });
      if (E.api.hola_pro) info.hola_pro = 1;
      if (E.api.test_env) info.test = 1;
      if (E.test.plus_layout2) info.plus_layout2 = 1;
      info.payment_method = E.api.payment_method;
      if (E.test.cc_payment) info.cc_payment_path = test_collapse(E.test.cc_payment);
      var ext_info = ((_be5 = be) === null || _be5 === void 0 ? void 0 : _be5.get('ext.info')) || {};
      info.ext_info = _.pick(ext_info, 'uuid', 'ver', 'install_ts');
      if (!info.ext_info.uuid) info.ext_info.uuid = qs.uuid;
      if (info.error) info.error = '' + info.error;
      var m = location.pathname.match(/\/join(\d+)/);
      var join_n = m && m[1];
      if (id.startsWith('www_premium') && join_n) {
        www_util.perr({
          id: id.replace('www_premium', `www_join${join_n}`),
          info
        });
      }
      return www_util.perr({
        id,
        info
      });
    } catch (e) {
      console.error('perr failed %s %s', id, e);
    }
  };
  E.save_email = email => etask.fn(function* () {
    try {
      yield $.post('/users/set_email', {
        email
      });
    } catch (e) {
      E.perr({
        id: 'www_premium_payment_save_email_err',
        info: {
          email,
          err: zerr.e2s(e)
        }
      });
    }
  });
  var get_uuid = () => {
    var _be6, _be7;
    var qs = zurl.qs_parse_url(location.href, {
      safe: true
    });
    var ext_info = ((_be6 = be) === null || _be6 === void 0 ? void 0 : _be6.get('ext.info')) || {};
    return ((_be7 = be) === null || _be7 === void 0 ? void 0 : _be7.get_uuid()) || ext_info.uuid || qs.uuid;
  };
  E.get_custom_opt = () => {
    var _be8, _be9, _be9$ext;
    var browser = user_agent.guess_browser();
    var browser_name = www_util.get_browser(browser);
    var res = {
      ver: hopt.version,
      remote_ip: hopt.user_ip,
      browser: browser_name + ' ' + (browser_name == 'opera' ? browser.opera_version : browser.version),
      os: www_util.sys.os,
      mobile: +www_util.sys.mobile
    };
    if ((_be8 = be) !== null && _be8 !== void 0 && _be8.ext()) res.ext_ver = (_be9 = be) === null || _be9 === void 0 ? void 0 : (_be9$ext = _be9.ext()) === null || _be9$ext === void 0 ? void 0 : _be9$ext.ver;
    var qs = zurl.qs_parse_url(location.href, {
      safe: true
    });
    var marketing_obj = www_util.marketing_obj || {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_match', 'gclid', 'gbraid', 'wbraid', 'a_aid', 'a_bid', 'a_cid', 'cio_campaign', 'cio_source', 'cio_medium'].forEach(utm => {
      var val = qs[utm] || cookie.get(`hola_${utm}`) || marketing_obj[utm],
        pval;
      try {
        if (val && (pval = JSON.parse(val)) && Array.isArray(pval)) val = pval[0];
      } catch (e) {}
      zutil.if_set(val, res, utm);
    });
    zutil.if_set(E.get_url_ref(), res, 'ref');
    zutil.if_set(get_uuid(), res, 'uuid');
    zutil.if_set(qs.root_url, res, 'root_url');
    // compact names of affiliate parameters
    if (!window.no_pap) {
      zutil.if_set(cookie.get('holapap_visitor_id'), res, 'avid');
      zutil.if_set(cookie.get('hola_a_aid'), res, 'aaid');
      zutil.if_set(cookie.get('hola_a_bid'), res, 'abid');
      zutil.if_set(cookie.get('hola_a_cid'), res, 'acid');
      zutil.if_set(cookie.get('holapap_aff_subid'), res, 'asid');
      zutil.if_set(cookie.get('holapap_aff_subid2'), res, 'asid2');
      zutil.if_set(cookie.get('holapap_aff_subid3'), res, 'asid3');
    }
    return res;
  };
  E.empty_email_err = 'This email creates your account';
  E.get_email = (email, user) => {
    email = _.get(user, 'emails.0.value') || email;
    if (!email) {
      var el = document.querySelector('.email_field [name="email"]');
      email = el && el.value;
    }
    return (email || '').trim().toLowerCase();
  };
  E.validate_email_syntax = email => {
    email = (email || '').trim().toLowerCase();
    return !email ? E.empty_email_err : zurl.is_valid_email(email) ? '' : 'Invalid email provided';
  };
  E.validate_email_domain = email => etask(function* () {
    email = (email || '').trim().toLowerCase();
    if (!email) return E.empty_email_err;
    var err_dom = (yield $.get('/users/validate_email_domain?' + zescape.qs({
      email: email
    }))).err_domain;
    return !err_dom ? '' : `Please use another email. We don't allow @${err_dom} email address`;
  });
  E.email_validator = email => etask(function* () {
    if (hopt.www_hola.no_email_validation_on_blur) return '';
    var err = email && E.validate_email_syntax(email);
    return err ? err : yield E.validate_email_domain(email);
  });
  E.login_get_user = force => {
    var cache = login_get_user_cache;
    if (!force && cache.ts && Date.now() - cache.ts < zdate.ms.MIN) return cache.data.user;
    return etask(function* () {
      try {
        var user = yield www_util.get_user();
        if (!user_membership) user_membership = yield www_util.get_membership();
        if (user.user) {
          user.user.already_plus = user_membership && zmembership.is_active(user_membership);
        }
        assign(cache, {
          data: user,
          ts: Date.now()
        });
        var api = E.api;
        var qs = zurl.qs_parse_url(location.href, {
          safe: true
        });
        if (qs.test === undefined) api.test_env = api.test_env || user.env == 'test';
        api.loaded = true;
        return user.user;
      } catch (e) {
        console.error(e);
      }
    });
  };
  E.get_url_plan = plans_info => {
    var qs = zurl.qs_parse_url(location.href, {
      safe: true
    });
    if (qs.plan_id) {
      var plan;
      if (plan = plans_info.find(pl => pl.id == qs.plan_id)) return plan;
      if (plan = hopt.all_plans.find(pl => pl.id == qs.plan_id)) return plan;
    }
    var m = qs.plan && qs.plan.match(/(\d)\s?([dwmy])/i);
    if (!m) return;
    return plans_info[m[1] + ' ' + m[2].toUpperCase()];
  };
  E.get_err_text = err => err.pub_reason || err.message || err.statusText || err.statusMessage;
  E.img_url = img => url2md5(`/www/hola/pub/img/${img}`);
  var add_trans_info = params => etask(function* () {
    try {
      var res = yield $.post('/users/payment/add_trans_info', params);
      return {
        id: res && res.id
      };
    } catch (e) {
      E.perr({
        id: 'www_premium_payment_failed_add_trans_info',
        info: {
          params,
          err: zerr.e2s(e)
        }
      });
      return {
        info: JSON.stringify(params)
      };
    }
  });
  var get_bs_ccard = frm => ({
    encryptedCardNumber: frm.ccard_number,
    expirationYear: +frm.ccard_exp_year,
    expirationMonth: +frm.ccard_exp_month,
    encryptedSecurityCode: frm.ccard_cvv
  });
  var get_bs_plan_path = ext => {
    return (ext ? 'bluesnap_ext' : 'bluesnap') + (E.api.test_env ? '_test_id' : '_id');
  };
  var get_bs_payment_opt = ({
    plan,
    currency
  }) => {
    var ext_api = E.api.cc_payment_path.includes('.ext');
    var price_plan = zmembership.get_price_plan(plan, currency);
    var plan_id = _.get(price_plan, get_bs_plan_path(ext_api));
    if (!plan_id) {
      ext_api = false; // fallback to standard api plan
      plan_id = _.get(price_plan, get_bs_plan_path());
    }
    var res = {
      plan_id,
      ext_api: +ext_api,
      cc_payment_path: E.api.cc_payment_path
    };
    return res;
  };
  E.bluesnap_get_cc_country = (frm, reuse, ctx) => etask(function* () {
    if (reuse && frm.country) return frm.country;
    ctx = ctx || {};
    assign(ctx, {
      uuid: get_uuid()
    });
    frm = pay_ccardbs._encrypt_ccard_form_data(frm);
    try {
      return yield $.post('/users/payment/bluesnap_cc_country', {
        bs_ccard: get_bs_ccard(frm),
        sbx: E.api.test_env,
        vat: E.api.cc_payment_path.includes('.ext.vat.on'),
        ctx
      });
    } catch (e) {}
  });
  var on_3ds_cb;
  var bluesnap_hpf_api = opt => {
    var provider = 'bluesnap_hpf';
    var before_payment = opt.before_payment,
      after_payment = opt.after_payment,
      fraud_session_id = opt.fraud_session_id,
      ccard_holder = opt.ccard_holder,
      user_email = opt.user_email,
      on_err = opt.on_err,
      on_already_plus_err = opt.on_already_plus_err,
      three_ds_auth_result = opt.three_ds_auth_result;
    if (user_membership && zmembership.is_active(user_membership)) return on_already_plus_err();
    return etask(function* () {
      this.finally(() => after_payment('bluesnap', 'api'));
      this.catch(e => {
        e = assign(e.is_err ? e : new Error(E.generic_err), {
          pub_reason: e.pub_reason || E.generic_err,
          fraud: /Email (invalid|blacklisted)/.test(e.responseText),
          no_report: 1
        });
        on_err(e);
        this.throw(e);
      });
      var subscr_opt = yield before_payment('bluesnap', 'api', opt);
      if (!subscr_opt) return;
      var is_new_user = subscr_opt.is_new_user,
        email = subscr_opt.email,
        user = subscr_opt.user,
        plan = subscr_opt.plan,
        period = subscr_opt.period,
        cart = subscr_opt.cart;
      if (email && !is_new_user && !user_email) yield E.save_email(email);
      if (!plan && !cart) {
        E.perr({
          id: 'www_premium_payment_no_plan',
          info: {
            provider
          }
        });
        return;
      }
      var route = get_bs_payment_opt(subscr_opt);
      var plan_id = route.plan_id;
      E.set_payment_cookie(user, plan, provider);
      var qs = zurl.qs_parse_url(location.href, {
        safe: true
      });
      E.perr({
        id: 'www_premium_payment_submit_bluesnap',
        info: {
          hola_uid: user.hola_uid,
          period,
          hola_plan_id: plan.id,
          plan_id,
          price: subscr_opt.price,
          three_ds_auth_result
        }
      });
      var _payutils$split_name = payutils.split_name('' + ccard_holder),
        _payutils$split_name2 = _slicedToArray(_payutils$split_name, 2),
        first_name = _payutils$split_name2[0],
        last_name = _payutils$split_name2[1];
      var params = {
        route,
        subscr_opt,
        // includes cart and bundle
        payment_opt: assign({
          session_id: fraud_session_id,
          name: ccard_holder,
          bs_ccard_holder: {
            firstName: first_name,
            lastName: last_name
          }
        }, _.pick(opt, 'pf_token', 'three_ds_ref_id', 'ccard_country', 'ccard_type', 'ccard_lbl', 'ccard_bank', 'ccard_sub_type', 'ccard_bin', 'ccard_bin_category', 'ccard_category', 'ccard_exp')),
        custom_opt: E.get_custom_opt()
      };
      if (E.api.test_env) params.sandbox = true;
      zutil.if_set(qs.simulate_err_code, params, 'simulate_err_code');
      zutil.if_set(qs.simulate_err_reason, params, 'simulate_err_reason');
      E.test_log('bluesnap_hpf_api params', params);
      var res = yield $.post('/users/payment/bluesnap_payment', params);
      if (res && res.is_err && res.reason_code != 'DUPLICATE_TRANSACTION') {
        throw assign(new Error(res && res.pub_reason || E.generic_err), res, {
          is_err: true
        });
      }
      location.href = E.after_payment_page(assign({
        gateway: 'bluesnap'
      }, subscr_opt));
    });
  };
  var bluesnap_gpay_api = opt => {
    var provider = 'bluesnap_gpay';
    var before_payment = opt.before_payment,
      after_payment = opt.after_payment,
      google_pay_token = opt.google_pay_token,
      google_pay_email = opt.google_pay_email,
      user_email = opt.user_email,
      on_err = opt.on_err,
      on_already_plus_err = opt.on_already_plus_err;
    if (user_membership && zmembership.is_active(user_membership)) return on_already_plus_err();
    return etask(function* () {
      this.finally(() => after_payment('bluesnap', 'gpay'));
      this.catch(e => {
        e = assign(e.is_err ? e : new Error(E.generic_err), {
          pub_reason: e.pub_reason || E.generic_err,
          fraud: /Email (invalid|blacklisted)/.test(e.responseText),
          no_report: 1
        });
        on_err(e);
        this.throw(e);
      });
      var subscr_opt = yield before_payment('bluesnap', 'gpay', opt);
      if (!subscr_opt) return;
      var is_new_user = subscr_opt.is_new_user,
        email = subscr_opt.email,
        user = subscr_opt.user,
        plan = subscr_opt.plan,
        period = subscr_opt.period;
      if (email && !is_new_user && !user_email) yield E.save_email(email);
      if (!plan) {
        E.perr({
          id: 'www_premium_payment_no_plan',
          info: {
            provider
          }
        });
        return;
      }
      var route = get_bs_payment_opt(subscr_opt);
      var plan_id = route.plan_id;
      E.set_payment_cookie(user, plan, provider);
      var qs = zurl.qs_parse_url(location.href, {
        safe: true
      });
      E.perr({
        id: 'www_premium_payment_submit_bluesnap_gpay',
        info: {
          hola_uid: user.hola_uid,
          period,
          hola_plan_id: plan.id,
          plan_id,
          price: subscr_opt.price
        }
      });
      var params = {
        route,
        subscr_opt,
        payment_opt: {
          google_pay_token,
          google_pay_email
        },
        custom_opt: E.get_custom_opt()
      };
      if (E.api.test_env) params.sandbox = true;
      zutil.if_set(qs.simulate_err_code, params, 'simulate_err_code');
      zutil.if_set(qs.simulate_err_reason, params, 'simulate_err_reason');
      var res = yield $.post('/users/payment/bluesnap_payment', params);
      if (res && res.is_err && res.reason_code != 'DUPLICATE_TRANSACTION') {
        throw assign(new Error(res && res.pub_reason || E.generic_err), res, {
          is_err: true
        });
      }
      location.href = E.after_payment_page(assign({
        gateway: 'bluesnap'
      }, subscr_opt));
    });
  };
  var bluesnap_applepay_api = opt => {
    var provider = 'bluesnap_applepay';
    var before_payment = opt.before_payment,
      after_payment = opt.after_payment,
      apple_pay_token = opt.apple_pay_token,
      user_email = opt.user_email,
      on_err = opt.on_err,
      on_already_plus_err = opt.on_already_plus_err,
      session = opt.session,
      apple_pay_payment_method = opt.apple_pay_payment_method,
      apple_pay_email = opt.apple_pay_email;
    if (user_membership && zmembership.is_active(user_membership)) return on_already_plus_err();
    return etask(function* () {
      this.finally(() => after_payment('bluesnap', 'applepay'));
      this.catch(e => {
        e = assign(e.is_err ? e : new Error(E.generic_err), {
          pub_reason: e.pub_reason || E.generic_err,
          fraud: /Email (invalid|blacklisted)/.test(e.responseText),
          no_report: 1
        });
        on_err(e);
        this.throw(e);
      });
      var subscr_opt = yield before_payment('bluesnap', 'applepay', opt);
      if (!subscr_opt) return;
      var is_new_user = subscr_opt.is_new_user,
        email = subscr_opt.email,
        user = subscr_opt.user,
        plan = subscr_opt.plan,
        period = subscr_opt.period;
      if (email && !is_new_user && !user_email) yield E.save_email(email);
      if (!plan) {
        E.perr({
          id: 'www_premium_payment_no_plan',
          info: {
            provider
          }
        });
        return;
      }
      var route = get_bs_payment_opt(subscr_opt);
      var plan_id = route.plan_id;
      E.set_payment_cookie(user, plan, provider);
      var qs = zurl.qs_parse_url(location.href, {
        safe: true
      });
      E.perr({
        id: 'www_premium_payment_submit_bluesnap_applepay',
        info: {
          hola_uid: user.hola_uid,
          period,
          hola_plan_id: plan.id,
          plan_id,
          price: subscr_opt.price
        }
      });
      var params = {
        route,
        subscr_opt,
        payment_opt: {
          apple_pay_token,
          apple_pay_payment_method,
          apple_pay_email
        },
        custom_opt: E.get_custom_opt()
      };
      if (E.api.test_env) params.sandbox = true;
      zutil.if_set(qs.simulate_err_code, params, 'simulate_err_code');
      zutil.if_set(qs.simulate_err_reason, params, 'simulate_err_reason');
      var res = yield $.post('/users/payment/bluesnap_payment', params);
      if (res && res.is_err && res.reason_code != 'DUPLICATE_TRANSACTION') {
        throw assign(new Error(res && res.pub_reason || E.generic_err), res, {
          is_err: true
        });
      }
      if (session) session.completePayment(window.ApplePaySession.STATUS_SUCCESS);
      location.href = E.after_payment_page(assign({
        gateway: 'bluesnap'
      }, subscr_opt));
    });
  };
  E.on_3ds = res => {
    if (on_3ds_cb) return on_3ds_cb(res);
  };
  var avangate_inited;
  E.init_avangate = (opt = {}) => {
    var api = window.TwoCoInlineCart;
    if (avangate_inited) return api;
    api.setup.setMerchant('HOLANETW');
    api.register();
    api.cart.setReset(true);
    if (opt.on_open) api.events.subscribe('cart:opened', opt.on_open);
    if (opt.on_close) api.events.subscribe('cart:closed', opt.on_close);
    if (opt.on_payment) api.events.subscribe('payment:finalized', opt.on_payment);
    avangate_inited = true;
    return api;
  };
  var avangate_inline_api = opt => {
    var provider = 'avangate_inline';
    var before_payment = opt.before_payment,
      after_payment = opt.after_payment,
      on_err = opt.on_err;
    return etask(function* () {
      this.on('finally', () => after_payment());
      try {
        var _opt = yield before_payment('avangate', 'inline', opt);
        if (!_opt) return;
        var plan = _opt.plan,
          user = _opt.user,
          email = _opt.email,
          currency = _opt.currency;
        var price_plan = zmembership.get_price_plan(plan, currency);
        E.test_log('avangate_inline price_plan', price_plan);
        if (!user) user = yield E.login_get_user();
        if (!plan) {
          E.perr({
            id: 'www_premium_payment_no_plan',
            info: {
              provider
            }
          });
          return;
        }
        E.set_payment_cookie(user, plan, provider);
        var api;
        try {
          api = E.init_avangate({
            on_open: () => E.perr({
              id: 'www_premium_payment_avangate_inline_open',
              info: _opt
            }),
            on_payment: () => {
              E.perr({
                id: 'www_premium_payment_avangate_inline_success',
                info: _opt
              });
              location.href = E.after_payment_page(assign({
                gateway: 'avangate'
              }, _opt));
            },
            on_close: () => {
              E.perr({
                id: 'www_premium_payment_avangate_inline_close',
                info: _opt
              });
              after_payment('avangate', 'inline');
            }
          });
        } catch (e) {
          E.perr({
            id: 'www_premium_payment_avangate_inline_init_err',
            info: _opt
          });
          return avangate_plain_api(opt);
        }
        api.billing.reset();
        api.products.removeAll();
        api.cart.setTest(!!E.api.test_env);
        var custom = yield add_trans_info(assign({
          gateway: 'avangate',
          hola_uid: user.hola_uid,
          period: plan.period,
          hola_plan_id: plan.id,
          type: plan.type
        }, E.get_custom_opt()));
        var ext_cust_ref = custom && custom.id ? JSON.stringify({
          trans_id: custom.id,
          plan_id: plan.id,
          period: plan.period
        }) : custom;
        api.cart.setExternalCustomerReference(ext_cust_ref);
        var country = hopt.user_country || '';
        if (country) api.billing.setCountry(country);
        currency = currency || hopt.user_currency;
        if (currency && zcountry.avangate_currency_list.includes(currency)) api.cart.setCurrency(currency);
        api.billing.setEmail(email);
        var product = {
          code: price_plan && price_plan.avangate_product || plan.avangate_product,
          quantity: 1
        };
        E.test_log('avangate_inline product', product);
        api.products.add(product);
        api.cart.checkout();
        return yield this.wait();
      } catch (e) {
        on_err(e);
      }
    });
  };
  var avangate_2pay_api = opt => {
    var provider = 'avangate_2pay';
    var before_payment = opt.before_payment,
      token = opt.token,
      name = opt.name,
      user_email = opt.user_email,
      country = opt.country,
      state = opt.state,
      zip = opt.zip;
    return etask(function* () {
      var _opt = yield before_payment('avangate', 'api', opt);
      if (!_opt) return;
      var is_new_user = _opt.is_new_user,
        email = _opt.email,
        user = _opt.user,
        plan = _opt.plan,
        period = _opt.period,
        currency = _opt.currency,
        vat_obj = _opt.vat_obj,
        coupon = _opt.coupon;
      if (email && !is_new_user && !user_email) yield E.save_email(email);
      if (!plan) {
        E.perr({
          id: 'www_premium_payment_no_plan',
          info: {
            provider
          }
        });
        return;
      }
      var price_plan = zmembership.get_price_plan(plan, currency);
      var id_key = vat_obj && vat_obj.gateway == 'avangate' && vat_obj.vat_percent ? 'net.avangate_id' : 'avangate_id';
      var avangate_id = _.get(price_plan, id_key) || _.get(plan, id_key) || _.get(price_plan, 'avangate_id') || _.get(plan, 'avangate_id');
      E.set_payment_cookie(user, plan, provider);
      var res = yield etask.all([$.post('/users/payment/avangate_2pay', assign({
        email,
        name,
        country,
        state,
        zip,
        token,
        currency,
        coupon,
        sbx: E.api.test_env,
        plan_id: avangate_id,
        hostname: window.location.hostname,
        hola_plan_id: plan.id
      }, E.get_custom_opt())), E.perr({
        id: 'www_premium_payment_submit_avangate',
        info: {
          payment_type: 'api',
          avangate_id,
          vat_obj,
          id_key,
          coupon,
          hola_uid: user.hola_uid,
          period,
          hola_plan_id: plan.id
        }
      })]);
      res = res && res[0];
      if (res.Errors) throw res.Errors.find(Boolean);
      if (res.auth_3ds_url) {
        E.perr({
          id: 'www_premium_payment_avangate_2pay_3ds_started',
          info: {
            email,
            period,
            currency
          }
        });
        var popup = modal.open_remote_modal({
          url: res.auth_3ds_url,
          no_bg_close: true,
          no_kb_close: true,
          on_cancel: () => {
            this.throw({
              pub_reason: '3D Secure canceled'
            });
          }
        });
        window.avangate_3ds_cb = success => {
          popup.close();
          if (!success) this.throw({
            pub_reason: '3D Secure failed'
          });
          E.perr({
            id: 'www_premium_payment_avangate_2pay_3ds_success',
            info: {
              email,
              period,
              currency
            }
          });
          this.return(res);
        };
        return yield this.wait();
      }
      return res;
    });
  };
  var vat_cache = {};
  E.get_vat = (gateway, opt) => etask(function* () {
    opt = _.pick(opt, 'product_id', 'currency', 'country', 'state', 'zip');
    if (opt.country == 'US' && (!opt.zip || !zcountry.get_state_by_zip(opt.zip))) delete opt.zip;
    var cache_id = gateway + '-' + _.values(opt).join('-');
    if (vat_cache[cache_id] !== undefined) return vat_cache[cache_id];
    var res = yield $.get('/users/payment/get_vat', assign({
      gateway
    }, E.api.test_env && {
      sandbox: true
    }, opt));
    return vat_cache[cache_id] = res ? assign({
      gateway
    }, opt, res) : false;
  });
  E.payment_api = (type, opt) => {
    switch (type) {
      case 'avangate_plain':
        return avangate_plain_api(opt);
      case 'avangate_inline':
        return avangate_inline_api(opt);
      case 'avangate_2pay':
        return avangate_2pay_api(opt);
      case 'bluesnap_gpay':
        return bluesnap_gpay_api(opt);
      case 'bluesnap_hpf':
        return bluesnap_hpf_api(opt);
      case 'bluesnap_applepay':
        return bluesnap_applepay_api(opt);
      case 'bluesnap_apm':
        return bluesnap_apm_api(opt);
      case 'stripe':
        return stripe_api(opt);
      case 'adyen':
        return adyen_api(opt);
    }
  };
  E.get_stripe_plan_id = (plan, currency) => {
    var price_plan = zmembership.get_price_plan(plan, currency);
    var id_key = E.api.test_env ? 'stripe_test_id' : 'stripe_id';
    return _.get(price_plan, id_key) || _.get(plan, id_key);
  };
  E.get_bluesnap_plan_id = (plan, currency) => {
    var price_plan = zmembership.get_price_plan(plan, currency);
    var id_key = E.api.test_env ? 'bluesnap_test_id' : 'bluesnap_id';
    return _.get(price_plan, id_key) || _.get(plan, id_key);
  };
  var ensure_hola_uid = (user, email) => user ? user.hola_uid : email && 'basic/' + email;
  var stripe_api = opt => {
    var sbx = E.api.test_env;
    E.test_log('stripe api', opt);
    var provider = 'stripe_api';
    var before_payment = opt.before_payment,
      payment_method_id = opt.payment_method_id,
      name = opt.name,
      user_email = opt.user_email,
      stripe = opt.stripe,
      usage_charges = opt.usage_charges,
      zone_id = opt.zone_id,
      group_id = opt.group_id,
      extra_limit = opt.extra_limit,
      is_renew_payment = opt.is_renew_payment,
      with_trial = opt.with_trial,
      trial_period_days = opt.trial_period_days,
      _currency = opt._currency,
      migrate_product_id = opt.migrate_product_id,
      with_refund = opt.with_refund,
      refund_product_id = opt.refund_product_id;
    var quantity = opt.quantity || 1;
    return etask(function* () {
      var subscr_opt = yield before_payment('stripe', 'api', opt);
      if (!subscr_opt) return {
        error: 'no subscr_opt'
      };
      E.test_log('subscr_opt api', subscr_opt);
      var email = subscr_opt.email,
        user = subscr_opt.user,
        plan = subscr_opt.plan,
        bundle = subscr_opt.bundle,
        cart = subscr_opt.cart,
        period = subscr_opt.period,
        currency = subscr_opt.currency,
        coupon = subscr_opt.coupon;
      if (email && !subscr_opt.is_new_user && !user_email) yield E.save_email(email);
      if (!plan && !cart) {
        E.perr({
          id: 'www_premium_payment_no_plan',
          info: {
            provider
          }
        });
        return {
          error: 'no plan'
        };
      }
      if (plan) E.test_log('stripe plan', plan);else E.test_log('cart', cart);
      var plan_id;
      if (plan) {
        plan_id = E.get_stripe_plan_id(plan, currency);
        E.test_log('stripe plan_id', plan_id);
        E.set_payment_cookie(user, plan, provider);
      }
      var hola_uid = ensure_hola_uid(user, email);
      var price = subscr_opt.price;
      var info = zutil.omit_empty({
        hola_uid,
        period,
        hola_plan_id: plan === null || plan === void 0 ? void 0 : plan.id,
        plan_id,
        price,
        cart,
        bundle
      });
      E.perr({
        id: 'www_premium_payment_submit_stripe',
        info
      });
      var params = zutil.omit_empty(assign({
        hola_uid,
        email,
        name,
        currency,
        coupon,
        price,
        plan_id,
        sbx,
        cart,
        payment_method_id,
        hola_plan_id: plan === null || plan === void 0 ? void 0 : plan.id,
        bundle: bundle || (plan === null || plan === void 0 ? void 0 : plan.bundle),
        period,
        usage_charges,
        zone_id,
        group_id,
        extra_limit,
        quantity,
        _currency,
        is_renew_payment,
        migrate_product_id,
        with_refund,
        refund_product_id
      }, E.get_custom_opt()));
      if (location.href.indexOf('with_trial') > -1 || with_trial || trial_period_days !== null && trial_period_days !== undefined) {
        params.with_trial = true;
        // Extract trial_period_days from URL or use provided value
        var url_params = new URLSearchParams(location.search);
        var url_trial_days = url_params.get('trial_period_days');
        if (url_trial_days && !isNaN(+url_trial_days)) params.trial_period_days = +url_trial_days;else if (trial_period_days !== null && trial_period_days !== undefined && !isNaN(+trial_period_days)) {
          params.trial_period_days = +trial_period_days;
        }
      }
      E.test_log('stripe payment params', params);
      if (experiment_init.ui_test.test_discount_prices) params.use_discount = true;
      var res = yield $.post('/users/payment/stripe_payment', params);
      E.test_log('stripe payment result', res);
      if (res.client_secret) {
        assign(info, res);
        E.perr({
          id: 'www_premium_payment_stripe_3ds_init',
          info
        });
        var _this = this;
        stripe.confirmCardPayment(res.client_secret, {
          payment_method: payment_method_id
        }).then(result => {
          E.test_log('stripe confirm card result', result);
          if (!result) return _this.throw({
            error: 'no 3ds result'
          });
          if (result.error) {
            E.perr({
              id: 'www_premium_payment_stripe_3ds_err',
              info: assign({
                err: result.error
              }, info)
            });
            return _this.throw(assign({
              pub_reason: result.error.message
            }, result.error));
          }
          if (result.paymentIntent.status === 'succeeded') {
            E.perr({
              id: 'www_premium_payment_stripe_3ds_success',
              info
            });
            return etask(function* () {
              var _res = yield $.post('/users/payment/confirm_stripe_payment', {
                payment_intent_id: res.payment_intent_id,
                sbx
              });
              if (_res && _res.error == 'duplicate renewal') {
                // XXX dmitriiz: stripe sends webhook
                // race-condition marks some client-side
                // calls as "duplicate"
                delete _res.error;
              }
              return _this.return(_res);
            });
          }
          var err = zutil.get(result, 'paymentIntent.status');
          E.perr({
            id: 'www_premium_payment_stripe_3ds_err',
            info: assign({
              err,
              payment_intent: result && result.paymentIntent
            }, info)
          });
          _this.throw({
            error: err
          });
        }).catch(e => _this.throw(e));
        return yield this.wait();
      }
      return res;
    });
  };
  var avangate_plain_api = opt => {
    var before_payment = opt.before_payment,
      after_payment = opt.after_payment,
      on_err = opt.on_err;
    return etask(function* () {
      this.on('finally', after_payment);
      try {
        var _opt = yield before_payment('avangate', 'plain', opt);
        if (!_opt) return;
        var plan = _opt.plan,
          user = _opt.user,
          email = _opt.email;
        if (!user) user = yield E.login_get_user();
        if (!plan) {
          E.perr({
            id: 'www_premium_payment_no_plan',
            info: {
              provider: 'avangate'
            }
          });
          return;
        }
        E.set_payment_cookie(user, plan, 'avangate');
        var billing_url = 'https://secure.avangate.com';
        var ref = E.get_url_ref();
        E.perr({
          id: 'www_premium_payment_submit_avangate',
          info: {
            hola_uid: user.hola_uid,
            period: plan.period,
            hola_plan_id: plan.id,
            payment_type: 'plain'
          }
        });
        var qs = zurl.qs_parse_url(location.href, {
          safe: true
        });
        var checkout_url = billing_url + '/order/checkout.php?' + zescape.qs({
          QTY: 1,
          CART: 1,
          CARD: 2,
          CLEAN_CART: 1,
          PRODS: plan.avangate_id,
          DOTEST: E.api.test_env ? 1 : undefined,
          AUTO_PREFILL: 1,
          BACK_REF: E.after_payment_page(assign({
            gateway: 'avangate'
          }, _opt)),
          CUSTOMERID: JSON.stringify(assign({
            hola_uid: user.hola_uid,
            plan_id: plan.id
          }, E.get_custom_opt())),
          SRC: ref,
          GCLID: qs.gclid,
          SHORT_FORM: 1
        });
        location.href = billing_url + '/order/pf.php?' + zescape.qs({
          MERCHANT: 'HOLANETW',
          URL: checkout_url,
          BILL_FNAME: _.get(user, 'name.givenName', ''),
          BILL_LNAME: _.get(user, 'name.familyName', ''),
          BILL_EMAIL: email || _.get(user, 'emails[0].value', '')
        });
        return yield this.wait();
      } catch (e) {
        on_err(e);
      }
    });
  };
  var bluesnap_apm_api = opt => {
    var user_email = opt.user_email,
      before_payment = opt.before_payment,
      after_payment = opt.after_payment,
      on_err = opt.on_err;
    etask(function* () {
      this.on('finally', after_payment);
      try {
        var _opt = yield before_payment('bluesnap', 'apm');
        if (!_opt) return;
        var plan = _opt.plan,
          user = _opt.user,
          email = _opt.email,
          period = _opt.period,
          is_new_user = _opt.is_new_user,
          coupon = _opt.coupon;
        if (email && !is_new_user && !user_email) yield E.save_email(email);
        if (!user) user = yield E.login_get_user();
        if (!plan) {
          E.perr({
            id: 'www_premium_payment_no_plan',
            info: {
              provider: 'bluesnap_apm'
            }
          });
          return;
        }
        E.set_payment_cookie(user, plan, 'bluesnap_apm');
        var info = {
          hola_uid: user.hola_uid,
          period: plan.period,
          hola_plan_id: plan.id,
          coupon
        };
        E.perr({
          id: 'www_premium_payment_submit_clicked_bluesnap_apm',
          info
        });
        E.perr({
          id: 'www_premium_payment_submit_bluesnap_apm',
          info
        });
        var params = assign({
          email,
          period,
          coupon,
          hola_plan_id: plan.id,
          plan_id: E.api.test_env ? plan.bluesnap_test_id : plan.bluesnap_id,
          back_url: E.after_payment_page(assign({
            gateway: 'bluesnap'
          }, _opt))
        }, E.get_custom_opt());
        if (E.api.test_env) params.test = 1;
        var res = yield $.post('/users/payment/bluesnap_apm', params);
        cookie.remove('user');
        location.href = res.url;
        return yield this.wait();
      } catch (e) {
        on_err(e);
      }
    });
  };
  var adyen_api = opt => {
    E.test_log('adyen api', opt);
    var provider = 'adyen_api';
    var before_payment = opt.before_payment,
      after_payment = opt.after_payment,
      user_email = opt.user_email,
      on_err = opt.on_err;
    return etask(function* () {
      var _opt, res;
      this.on('finally', () => after_payment(res));
      try {
        _opt = yield before_payment('adyen', 'api', opt);
        if (!_opt) return;
        E.test_log('adyen opt api', _opt);
        var _opt2 = _opt,
          plan = _opt2.plan,
          user = _opt2.user,
          email = _opt2.email,
          coupon = _opt2.coupon,
          price = _opt2.price,
          currency = _opt2.currency;
        var country_code = opt.country_code,
          reference = opt.reference,
          state = opt.state,
          token = opt.token;
        if (email && !_opt.is_new_user && !user_email) yield E.save_email(email);
        if (!plan) {
          E.perr({
            id: 'www_premium_payment_no_plan',
            info: {
              provider
            }
          });
          return {
            error: 'no plan'
          };
        }
        E.set_payment_cookie(user, plan, 'adyen_apm');
        var hola_uid = ensure_hola_uid(user, email);
        var info = {
          hola_uid,
          period: plan.period,
          coupon,
          country_code,
          price,
          currency,
          reference
        };
        E.perr({
          id: 'www_premium_payment_submit_adyen',
          info
        });
        var sbx = E.api.test_env || _opt.sbx;
        var params = zutil.omit_empty(assign({
          hola_uid,
          email,
          currency,
          coupon,
          price,
          hola_plan_id: plan.id,
          country_code,
          reference,
          token,
          sbx,
          state,
          back_url: E.after_payment_page(assign({
            gateway: 'adyen',
            full_host: true
          }, _opt))
        }, E.get_custom_opt()));
        E.test_log('adyen payment params', params);
        if (E.api.test_env) params.test = 1;
        res = yield $.post('/users/payment/adyen', params);
        E.test_log('adyen payment result', res);
        return assign(res, params);
      } catch (e) {
        on_err(e);
      }
    });
  };
  E.redeem_errors = {
    bad_code: 'This code is invalid or has already been used',
    email_used: 'This email is already used - sign up with a new email or ' + 'use your existing account to sign in',
    bad_email: 'Invalid email',
    was_sent: 'Check your mailbox and follow the instructions to complete ' + 'the registration process',
    already_has_lifetime_membership: 'You already have a lifetime membership',
    bad_type: 'This code is invalid'
  };
  E.get_currency_o = (currency, plan, provider = 'bluesnap') => {
    var currencies = ['USD'];
    if (plan && plan.currency && hopt.user_currencies && !(provider == 'stripe' && E.test.stripe_usd_only)) {
      if (provider == 'paypal' && plan.period == '3 Y') {
        if (zcountry.paypal_currency_list.includes(currency)) currencies.push(currency);
      } else if (provider == 'adyen' && currency in zcountry.adyen_currency_units) {
        currencies.push(currency);
      } else {
        var _iterator2 = _createForOfIteratorHelper(hopt.user_currencies),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var c = _step2.value;
            var _plan = plan.currency[c.toLowerCase()];
            if (_plan && provider && _plan[provider]) currencies.push(c);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
    currencies = [...new Set(currencies)];
    currency = currencies.includes(currency) ? currency : 'USD';
    return {
      currency,
      currencies
    };
  };
  E.t = {
    rand_select: experiment_init.rand_select,
    mk_test_ref,
    is_test_enabled
  };
  if (!is_node) E.init_ab_testing();
  plans_util.set_plus_util(E);
  return E;
});